import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Services.css';
import SubHero from '../../components/SubHero/SubHero'
import heroImage from '../../images/hero2.jpg';
import { MdAnalytics } from "react-icons/md";
import { FaUserGraduate, FaCheckCircle } from "react-icons/fa";
import { BsFillPeopleFill } from "react-icons/bs";
import { FaFloppyDisk } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import Tag from '../../components/Tag/Tag'
import CommonCard from '../../components/CommonCard/CommonCard';


const ServicesPage = () => {
  useEffect(() => {

    window.scrollTo(0, 0)

    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out',
    });
  }, []);


  const main_service_data = [
    {
      title: "Social Media Page Management",
      msg: "We take full control of your social platforms (Facebook, Instagram, and more), ensuring consistency, strategy, and engagement. What You Get:",
      list: [
        "Page set-up or optimization",
        "Content scheduling & posting",
        "Engagement monitoring",
        "Inbox & comment response",
        "Monthly analytics reports",
        "Free 1-week sponsored ad per month",
      ]
    },
    {
      title: "Page Growth & Engagement",
      msg: "Get real results with our targeted strategies that drive followers, engagement, and reach.",
      list: [
        "Organic & ad-driven growth",
        "Audience-targeted strategies",
        "Reels/short-form content creation",
      ]
    },
    {
      title: "Sponsored Ads (Meta, TikTok, Google, Snapchat)",
      msg: "We don't just run ads — we run ads that work.",
      list: [
        "High-converting ad strategy",
        "Budget optimization",
        "A/B testing",
        "Ad creatives & audience targeting",
        "Campaign monitoring & reporting",
      ]
    },
    {
      title: "Content Creation (Graphics & Videos)",
      msg: "We turn ideas into scroll-stopping content that sells.",
      list: [
        "Promotional videos",
        "Motion graphics & text-only videos",
        "Reels for social platforms",
        "Custom branded visuals",
      ]
    },
    {
      title: "Business Consultation & Strategy",
      msg: "Need clarity on how to scale your brand online? We'll walk you through it.",
      list: [
        "1-on-1 consultations",
        "Strategy sessions",
        "Brand audits"      
      ]
    },
    {
      title: "Page Set-up & Optimization",
      msg: "We professionally set up or revamp your existing accounts for performance.",
      list: [
        "Bio optimization",
        "Highlights organization",
        "Branding elements (cover designs, story icons)"
      ]
    },
    {
      title: "Meta Business Page Verification",
      msg: "Add credibility and protection to your brand.",
      list: [
        "Official blue badge",
        "Increased ad performance & SEO",
        "Exclusive Meta support access"      
      ]
    },
    {
      title: "Website Design & Development",
      msg: "Your website is your digital headquarters — make it count.",
      list: [
        "Business, e-commerce, and portfolio websites",
        "UI/UX design",
        "SEO optimization",
        "Payment gateway integration",
        "Web hosting & domain setup"
      ]
    },
    {
      title: "Google Ads & Business Profile Creation",
      msg: "Be found where people search.",
      list: [
        "Google Search & Display Ads",
        "Google Business Profile setup",
        "Map listing & review optimization",
      ]
    },
    {
      title: "Custom Email Setup",
      msg: "Establish brand professionalism with yourname@yourcompany.com",
      list: [
        "Domain-linked emails",
        "Configuration & support"
      ]
    },
  ]

  const minor_services = [
    {
      title: 'Brand Identity',
      msg: "Logo design, brand guidelines, and visual identity systems that capture your brand essence.",
      icon: <FaUserGraduate />
    },
    {
      title: 'Social Media Marketing',
      msg: "Strategic social media campaigns that increase engagement and build community around your brand.",
      icon: <FaCheckCircle />
    },
    {
      title: 'E-commerce solutions',
      msg: "We build authentic relationships with our clients, treating their goals as our own.",
      icon: <BsFillPeopleFill />
    },
    {
      title: 'Digital Strategy',
      msg: "Comprehensive digital roadmaps aligned with your business objectives and market position.",
      icon: <FaFloppyDisk />
    },
  ]

  const approach_data = [
    {
      title: "Discovery",
      msg: "We start by understanding your business, goals, audience, and competitive landscape.",
      id: 100,
    },
    {
      title: "Strategy",
      msg: "We develop a customized plan with clear objectives, timelines, and measurable targets.",
      id: 200,
    },
    {
      title: "Execution",
      msg: "Our team brings the strategy to life with expert implementation and attention to detail.",
      id: 300,
    },
    {
      title: "Optimization",
      msg: "We continuously analyze results, gather insights, and refine for optimal performance.",
      id: 400,
    },
  ]





  return (
    <div className="Services">
      <SubHero 
        title = "Our Services"
        subtitle="Premium Digital Solutions for Brands That Want to Stand Out"
        image={heroImage}
      />


      <div className='BODY'>
        {/* Services Overview */}
        <div className="Services-overview">
          <div className="Services-container">
            <div className="Services-overview-content" data-aos="fade-up">
              <h2 className="Services-section-title Services-center header-1">How We Help You Succeed</h2>
              <p className="Services-overview-text text-1">                
                At Oma Media Space Limited, we offer a full spectrum of digital marketing services designed to position your brand for impact, growth, and recognition. From building your social presence to crafting your online identity — we've got every corner of the digital space covered.
              </p>
            </div>
          </div>
        </div>

        {/* Main Services Section */}
        <div className="Services-main">
          <div className="Services-container">
            <div className="Services-cards">
              {
                main_service_data?.map((service, serve_index) => {
                  return (
                    <div className="Services-card" data-aos="fade-up" data-aos-delay="100" key={serve_index}>
                      <div className="Services-card-icon header-2">
                        <MdAnalytics />
                      </div>
                      <h3 className="Services-card-title header-3"> {service.title} </h3>
                      <p className="Services-card-text"> {service.msg} </p>
                      <div className="Services-features">
                        {
                          service.list.map((list_item, list_item_key) => {
                            return (
                              <div className="Services-feature text-1" key={list_item_key}>
                                <svg className="Services-check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="goldenrod" strokeWidth="3">
                                  <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                                <span> {list_item} </span>
                              </div>
                            )
                          })
                        }
                  
                      </div>
                      <Link to="/contact" className="Services-card-link text-1">
                        Learn More <span className="Services-link-arrow">→</span>
                      </Link>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>

        {/* Secondary Services */}
        <div className="Services-secondary">
          <div className="Services-container">
            <span className="Services-section-title Services-center" data-aos="fade-up">
              <Tag 
                title="Additional Services"
                variant="primary"
              />
            </span>
            <div className="Services-secondary-grid">
              <CommonCard card_data={minor_services}/>
            </div>
          </div>
        </div>



        {/* Process Section */}
        <div className="Services-process">
          <div className="Services-container">
            <div className="Services-process-content">
              <span className="Services-section-title" data-aos="fade-up">
                <Tag 
                  title="Our Approach"
                  variant="primary"
                />
              </span>


              <div className="Services-process-steps">
                {
                  approach_data.map((data, idx) => {
                    return (
                      <div className="Services-process-step" data-aos="fade-up" data-aos-delay="100">
                        <div className="Services-step-number">0{idx}</div>
                        <div className="Services-step-content">
                          <h3 className="Services-step-title">{data.title}</h3>
                          <p className="Services-step-text">
                            { data.msg }
                          </p>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;